import { memo } from "react";
import { Collection } from "ui/support/Resource";
import When from "ui/support/When";
import type { ColumnsProps } from "./types";
import { useColumns } from "../../support";
import { Column as ColumnEnum } from "../../repository";
import Column from "./Column";
import { ColumnConstraints } from "./Columns";

const Reason = ({ row }: ColumnsProps) => {
    const { withAvailableColumns, getScalarColumns } = useColumns();

    return (
        <Collection
            collection={Object.entries(row)
                .filter(([key]) => (
                    ColumnConstraints.Reason.includes(key as ColumnEnum)
                ))}
            renderResource={([key, value]) => {
                const [colDef] = withAvailableColumns(getScalarColumns, [key]);

                return (
                    <When
                        key={key}
                        if={Boolean(colDef)}
                        then={() => (
                            <Column
                                sx={{
                                    justifyContent: 'center'
                                }}
                                name={colDef.headerName!}
                                value={value}
                            />
                        )}
                    />
                );
            }}
        />
    );
};

export default memo(Reason);
